// --- START: Shared hook for prefers-reduced-motion media query ---
import { useEffect, useState } from "react";

/**
 * Hook to detect if user prefers reduced motion
 * Used for respecting accessibility preferences in animations
 */
export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState<boolean>(() =>
    typeof window !== "undefined"
      ? window.matchMedia("(prefers-reduced-motion: reduce)").matches
      : false
  );

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mql = window.matchMedia("(prefers-reduced-motion: reduce)");
    const onChange = (e: MediaQueryListEvent) => setReduced(e.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return reduced;
}
// --- END: Shared hook for prefers-reduced-motion media query ---
